import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { FirebaseService, AuthService, City, Venue } from "src/app/core";

@Component({
  selector: "ll-filter-analytics",
  templateUrl: "./filter-analytics.component.html",
  styleUrls: ["./filter-analytics.component.scss"]
})
export class FilterAnalyticsComponent implements OnInit {
  objectKeys = Object.keys;

  form: FormGroup;
  public dow: any[];

  constructor(public fb: FirebaseService, private auth: AuthService) {
    this.reset("Month to Date");
  }

  updateClassName(){
    if(this.isAdmin){
      document.getElementById("filter-grid").className = "filter_a_grid";
    }else{
      document.getElementById("filter-grid").className = "filter_o_grid";
      
    }
  }

  get isAdmin() {
    return this.auth.admin;
  }

  get timeframes() {
    return this.fb.analytics.filter.timeframes;
  }
  get productTypes() {
    return this.fb.analytics.filter.productTypes;
  }
  get currentCity() {
    return this.fb.analytics.filter.currentCity;
  }
  set currentCity(city: City) {
    this.fb.analytics.filter.currentCity = city;
  }
  get currentVenue() {
    return this.fb.analytics.filter.currentVenue;
  }
  set currentVenue(venue: Venue) {
    this.fb.analytics.filter.currentVenue = venue;
  }
  get currentTimeframe() {
    return this.fb.analytics.filter.currentTimeframe;
  }
  get currentType() {
    return this.fb.analytics.filter.currentType;
  }
  set currentType(type) {
    this.fb.analytics.filter.currentType = type;
  }
  get currentDow() {
    return this.fb.analytics.filter.currentDow;
  }
  set currentDow(arg) {
    this.fb.analytics.filter.currentDow = arg;
  }
  get types() {
    return this.objectKeys(this.productTypes);
  }
  reset(tf: string) {
    this.form = new FormGroup({
      city: new FormControl("All"),
      venue:
        this.currentVenue != null
          ? new FormControl(this.currentVenue.name)
          : new FormControl("All"),
      timeframe: new FormControl(tf),
      productType: new FormControl("All"),
      dow: new FormControl("All")
    });
    this.dow = [
      {
        name: "All",
        checked: true
      },
      {
        name: "Monday",
        checked: true
      },
      {
        name: "Tuesday",
        checked: true
      },
      {
        name: "Wedneday",
        checked: true
      },
      {
        name: "Thursday",
        checked: true
      },
      {
        name: "Friday",
        checked: true
      },
      {
        name: "Saturday",
        checked: true
      },
      {
        name: "Sunday",
        checked: true
      }
    ];
  }

  ngOnInit() {

    this.updateClassName();

  }

  changeProductType(key: string) {
    this.form.controls.productType.setValue(key);
  }

  changeDOW(e: any) {
    var flag = true;
    for (var i = 1; i < this.dow.length; i++) {
      if (this.dow[i]["checked"] == false) flag = false;
    }
    this.dow[0]["checked"] = flag;
    this.form.controls.dow.setValue(this.getDateString());
    this.currentDow = this.getDateArray();
    this.filter();
  }
  dowAll() {
    this.dow = [
      {
        name: "All",
        checked: true
      },
      {
        name: "Monday",
        checked: true
      },
      {
        name: "Tuesday",
        checked: true
      },
      {
        name: "Wedneday",
        checked: true
      },
      {
        name: "Thursday",
        checked: true
      },
      {
        name: "Friday",
        checked: true
      },
      {
        name: "Saturday",
        checked: true
      },
      {
        name: "Sunday",
        checked: true
      }
    ];
  }
  onCheck(e: any) {
    if (e["name"] == "All" && e["checked"] == true) this.dowAll();
    else if (e["name"] != "All" && e["checked"] == false)
      this.dow[0]["checked"] = false;
  }

  allChecked = (): boolean => this.dow[0]["checked"];
  getDateString() {
    if (this.allChecked()) return "All";
    let x = "";
    if (this.dow[1]["checked"]) x += "M, ";
    if (this.dow[2]["checked"]) x += "T, ";
    if (this.dow[3]["checked"]) x += "W, ";
    if (this.dow[4]["checked"]) x += "Th, ";
    if (this.dow[5]["checked"]) x += "F, ";
    if (this.dow[6]["checked"]) x += "S, ";
    if (this.dow[7]["checked"]) x += "Su, ";
    return x.substr(0, x.length - 2);
  }
  getDateArray() {
    if (this.allChecked()) return [0, 1, 2, 3, 4, 5, 6];
    let x = [];
    if (this.dow[1]["checked"]) x.push(0);
    if (this.dow[2]["checked"]) x.push(1);
    if (this.dow[3]["checked"]) x.push(2);
    if (this.dow[4]["checked"]) x.push(3);
    if (this.dow[5]["checked"]) x.push(4);
    if (this.dow[6]["checked"]) x.push(5);
    if (this.dow[7]["checked"]) x.push(6);
    return x;
  }
  setDefault() {
    this.form = new FormGroup({
      city: new FormControl("All"),
      venue: new FormControl("All"),
      timeframe: new FormControl("Month to Date"),
      productType: new FormControl("All")
    });
  }
  get analytics() {
    return this.fb.analytics;
  }

  filter() {
    this.analytics.filter.filter();
    this.analytics.updateMetrics();
  }
  /** BEGIN CITIES FILTER */
  get cities(): City[] {
    return this.fb.city.cities.sort((one, two) =>
      one.city_name > two.city_name ? 1 : -1
    );
  }

  changeCity(city: City) {
    this.form.controls.city.setValue(city.city_name + ", " + city.state);
    this.currentCity = city;
    this.checkVenueForReset();
    this.filter();
  }

  resetCity() {
    this.form.controls.city.setValue("All");
    this.currentCity = null;
    this.checkVenueForReset();
    this.filter();
  }
  /** END CITIES FILTER */

  /** BEGIN VENUES FILTER */
  get venues(): Venue[] {
    if (this.currentCity != null) return this.fb.venues.filter(venue => venue.city.id == this.currentCity.id);
    if (!this.isAdmin) return this.fb.venues;
    return this.fb.venues;
  }

  changeVenue(venue: Venue) {
    this.form.controls.venue.setValue(venue.name);
    this.currentVenue = venue;
    this.filter();
  }

  resetVenue() {
    this.form.controls.venue.setValue("All");
    this.currentVenue = null;
    this.filter();
  }

  checkVenueForReset() {
    if (
      !this.venues
        .map(venue => venue.name)
        .includes(this.form.controls.venue.value)
    ) {
      this.form.controls.venue.setValue("All");
      this.currentVenue = null;
    }
  }
  /** END VENUES FILTER */

  /** BEGIN PRODUCT TYPE FILTER */

  changeType(type: string) {
    this.form.controls.productType.setValue(type);
    this.currentType = this.productTypes[type];
    this.filter();
  }

  resetType() {
    this.form.controls.productType.setValue("All");
    this.currentType = null;
    this.filter();
  }
  /** END PRODUCT TYPE FILTER */

  /** BEGIN TIMEFRAME FILTER */
  changeTimeframe(tf: string) {
    this.form.controls.timeframe.setValue(tf);
    this.fb.analytics.changeTimeframe(tf, this.timeframes[tf]);
  }
  /** END TIMEFRAME FILTER */
}
